"use client";

import "./Tombstone.css";
import { useTheme } from "./ThemeProvider";
import { transparentize } from "../utils/color";

export interface TombstoneProps {
  /**
   * The width of the tombstone.
   * @default "100%"
   */
  width?: string;
  /**
   * The height of the tombstone.
   * @default "1.5rem"
   */
  height?: string;
  /**
   * The border radius of the tombstone.
   * @default "4px"
   */
  borderRadius?: string;
}

/**
 * A component that displays a loading tombstone. For use as a placeholder while loading content
 * @interface TombstoneProps
 */
const Tombstone = ({
  width = "100%",
  height = "1.5rem",
  borderRadius = "4px",
}: TombstoneProps) => {
  const { theme, palette } = useTheme();

  const style = {
    "--tombstone-custom-background": palette.PRIMARY.PRIMARY_MEDIUM,
    "--tombstone-custom-primary": transparentize(
      palette.PRIMARY.PRIMARY_DARK,
      0.9
    ),
    "--tombstone-custom-secondary": transparentize(
      palette.SECONDARY.SECONDARY_DARK,
      0.7
    ),
  } as React.CSSProperties;

  return (
    <div
      className={`tombstone ${theme}`}
      style={{
        ...style,
        width,
        height,
        borderRadius,
      }}
    />
  );
};

export default Tombstone;
